import { Close } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { openNotification } from '../../../../helpers/notification';
import { regenerateFacilityInvoice } from '../../../../helpers/api';

export default function ReGenerateInvoice({ open, title, onClose, report }) {
  const [generating, setGenerating] = useState(false);

  const handleRegenerateInvoice = async () => {
    setGenerating(true);
    try {
      const res = await regenerateFacilityInvoice(report?.invoiceId);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        openNotification({ type: 'success', message: status?.desc });
        onClose();
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (err) {
      openNotification({
        type: 'error',
        message: 'Error trying to regenerate invoice. Please try again',
      });
    } finally {
      setGenerating(false);
    }
  };
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center', paddingTop: '1rem' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          {title}
        </DialogTitle>
        <Typography sx={{ marginLeft: 'auto', padding: '0 1rem' }}>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Typography>
      </Box>
      <DialogContent>
        <Alert severity="info">
          Regenerating {report?.reportTitle} for {report?.facility}
        </Alert>
        <br />
        <Typography variant="body2">
          {`If you proceed with this action the invoice for the facility will be regenerated`}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: '1rem 1.5rem 2rem 1.5rem' }}>
        {/* <Button
          type="button"
          size="medium"
          variant="contained"
          color="error"
          sx={{ textTransform: 'none', borderRadius: '30px' }}
          //onClick={handlePreviewInvoie}
          startIcon={generating && <CircularProgress size={20} />}
          disabled={generating}
        >
          ReGenerate and send
        </Button> */}
        <Button
          type="button"
          size="medium"
          variant="contained"
          sx={{ textTransform: 'none', borderRadius: '30px' }}
          onClick={handleRegenerateInvoice}
          startIcon={generating && <CircularProgress size={20} />}
          disabled={generating}
        >
          Regenerate
        </Button>
      </DialogActions>
    </Dialog>
  );
}
